import React, { createContext, ReactNode } from "react";

interface WalletContextType {
  // Placeholder for wallet context
  // Can be extended in the future for centralized wallet state
}

export const WalletContext = createContext<WalletContextType | undefined>(undefined);

interface WalletProviderProps {
  children: ReactNode;
}

export function WalletProvider({ children }: WalletProviderProps) {
  const value: WalletContextType = {
    // Wallet context values can be added here
  };

  return <WalletContext.Provider value={value}>{children}</WalletContext.Provider>;
}
